module.exports = __webpack_public_path__ + "static/barcelona_code_school_campus_-4-b8d73ac049310b88ab14e52a843aa2f2.jpg";